
import CountUp from 'react-countup'
import img1 from '../data/imgabout.jpg'
import img2 from '../data/imageabout2.jpg'
import img3 from '../data/imageabout3.jpg'
import { useState,useEffect } from 'react'


const images = [img1,img2,img3]
const AboutUs = () => {
   const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide effect
   useEffect(() => {
     const interval = setInterval(() => {
       setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
     }, 3000); // Change image every 3 seconds
 
     return () => clearInterval(interval); // Cleanup interval on unmount
   }, []);
 
  //  const nextSlide = () => {
  //    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  //  };
 
  //  const prevSlide = () => {
  //    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  //  };
 
  return (
    <div className='bg-black text-white'>
      {/* part-1 */}
      <div className='grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 '>
        <div className='grid mt-4 ml-4 gap-4 p-4'>
          <div className='font-barlow text-[30px] font-medium leading-[30px] text-red-700'>About Grim</div>
          <div className='font-barlow text-3xl lg:text-[52px] font-semibold leading-[52px]'>Experience the True Power of Energy with Grim!</div>
          <div className='font-barlow lg:text-[18px] font-normal leading-[24px] text-start p-4'>Epic nights or all-out adventures, Grim is your go-to fuel.
             More than just a drink—it’s the ultimate party booster, keeping you going strong and pushing limits.
              When life moves fast, Grim makes sure you never miss a beat.
               Packed with essential nutrients, it’s built for thrill-seekers who refuse to slow down.
                Whether you’re gearing up for an epic night or riding the after-party wave, Grim keeps your energy soaring.
                 Stay unstoppable with Grim!</div>
          <div>
            <button className='bg-red-700 p-2 rounded-tr-3xl rounded-bl-3xl w-[200px]'>Contact Now</button>
          </div>
        </div>

       <div className="w-full h-[600px] place-items-center p-4">
        {/* <button onClick={prevSlide}>◀️</button> */}
        <img src={images[currentIndex]} alt="slider" className="w-full lg:w-[400px] lg:h-[400px] " />
        {/* <button onClick={nextSlide}>▶️</button> */}
      </div>
      </div>
      {/* part 2 */}
      <div className='bg-neutral-950 w-full grid grid-rows-2'>
               <div className='grid lg:grid-cols-2 p-10 gap-4'>
                    <p className='text-white text-5xl text-start font-bold'>Figures That Tell the Truth</p>
                    <p className='text-white text-sm font-bold p-2 text-start'>
                      Every number has a story—a testament to dedication, passion, and the relentless drive we bring to everything we do.
                       These figures aren’t just data; they represent people, moments, and the unstoppable energy that fuels our journey forward!
                    </p>
               </div>

               <div className='grid lg:grid-cols-3'>
                {/* 1st */}
                  <div className='text-white'>
                    <div className='text-6xl font-bold'>
                      <CountUp start={0} end={30} duration={10} delay={1}/>
                      +
                      </div>
                    <div className='font-medium'>Team Members</div>
                      
                  </div>
                  {/* 2nd */}
                  <div className='text-white'>
                    <div className='text-6xl font-bold'>
                      <CountUp start={0} end={2} duration={20} delay={2}/>
                      +
                      </div>
                    <div className='font-medium'>Team Products</div>
                      
                  </div>
                  {/* 3rd */}
                  <div className='text-white'>
                    <div className='text-6xl font-bold'>
                      <CountUp start={0} end={500} duration={10} delay={1}/>
                      +
                      </div>
                    <div className='font-medium'>Satisfies Customers</div>
                      
                  </div>
               
               </div>
               
       
             
      </div>
      {/* part 3 */}
      <div className='w-full h-auto p-8 grid grid-cols-1 lg:grid-cols-2 place-items-center gap-4 text-white'>
        <div className='bg-neutral-950 lg:w-[600px] p-6 rounded-tl-3xl rounded-br-3xl'>
          <p className='bg-red-700 rounded-tl-3xl rounded-br-3xl p-2 font-semibold'>Mission</p>
          <p className='text-center'>To help you party harder and longer with unlimited energy.
             We aim to keep your fun going and help you enjoy your moment fully. 
             With Grim, your fun would never stop, and your good times would continue.</p>
        </div>
        <div className='bg-neutral-950 lg:w-[600px] p-6 rounded-tl-3xl rounded-br-3xl '>
          <p className='bg-red-700 rounded-tl-3xl rounded-br-3xl p-2 font-semibold'>Vision</p>
          <p className='text-center'>To become the go-to drink for every party and inspire people to live their every moment to the fullest.
             We envisioned redefining the party culture with a drink that offers energy, fun, and an unforgettable experience.</p>
        </div>
      </div>
    </div>
  )
}

export default AboutUs